import React, {useEffect} from 'react';
import {useField} from "formik";
import FieldHeader from "./FieldHeader";
import Uploader from "../../Uploader";
import {AnyMedia, MediaFile, Type} from "types/MediaFile";
import {UploaderProps} from "../../Uploader/Uploader";
import {Icon} from "types/Icon";
import {classNames} from "../../../../services/string";

function toFieldValue(files: UploaderProps['files'], maxFiles: number = 100) {
    const idList = [files]
        .flat()
        .filter(Boolean)
        .map(file => (file as MediaFile | AnyMedia).id.toString())

    return (maxFiles < 2)? (idList[0] ?? '') : idList
}

// Component ----

export type MediaFieldProps = {
    name: string
    id?: string
    label?: string
    hint?: string
    type?: Type | Array<Type>
    files?: MediaFile | AnyMedia | Array<MediaFile | AnyMedia> | null
    maxFiles?: number
    minFiles?: number
    maxFileSize?: number
    icon?: Icon
    disabled?: boolean
}

function MediaField({label, hint, files, ...props}: MediaFieldProps) {
    const [, meta, {setValue, setTouched}] = useField(props.name)

    // Force the field value to be synchronised with the files given
    useEffect(() => {
        setValue(
            toFieldValue(files, props.maxFiles)
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (files: Array<MediaFile>) => {
        setTouched(true)
        setValue(
            toFieldValue(files, props.maxFiles)
        )
    }

    // Error state
    const hasError = meta.touched && !!meta.error

    return (
        <div>
            {!!label && <FieldHeader fieldId={props.id || props.name} label={label} hint={hint} />}

            <div className={classNames(!!label && 'mt-2')}>
                <Uploader
                    id={props.id || props.name}
                    onChange={handleChange}
                    error={hasError? meta.error : null}
                    files={files}
                    {...props}
                />
            </div>
        </div>
    );
}

// Expose the list of available types
MediaField.types = Uploader.types

export default MediaField;